// Semantic token names matching `sizes` in chakraTheme.ts.
// Use directly in Chakra props: w="sidebar-expanded", h="navbar", etc.
// For calc() expressions, use the CSS variable form: `calc(100vh - var(--chakra-sizes-navbar))`

export const sizes = {
  navbar: 'navbar',
  sidebarExpanded: 'sidebar-expanded',
  sidebarCollapsed: 'sidebar-collapsed',
  subSidebar: 'sub-sidebar',
  subSidebarSm: 'sub-sidebar-sm',
  sidePanel: 'side-panel',
  searchInput: 'search-input',
} as const;

export const sizeVars = {
  navbar: 'var(--chakra-sizes-navbar)',
  sidebarExpanded: 'var(--chakra-sizes-sidebar-expanded)',
  sidebarCollapsed: 'var(--chakra-sizes-sidebar-collapsed)',
  subSidebar: 'var(--chakra-sizes-sub-sidebar)',
  subSidebarSm: 'var(--chakra-sizes-sub-sidebar-sm)',
} as const;

// Raw rem values for non-Chakra contexts (e.g. framer-motion animations)
export const sizeValues = {
  subSidebar: '15.25rem',
  subSidebarSm: '11.25rem',
} as const;
